import {
    Component,
    DoCheck,
    ElementRef,
    EventEmitter,
    Input, IterableDiffer,
    IterableDiffers,
    OnDestroy,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { UxMessage } from '@eui/core';
@Component({
    selector: 'eui-growl',
    templateUrl: './eui-growl.component.html',
    styleUrls: ['./styles/_index.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiGrowlComponent implements DoCheck, OnDestroy {

    @Input() sticky: boolean = false;
    @Input() life: number = 3000;
    @Input() value: UxMessage[] = [];
    @Input() style: any;
    @Input() styleClass: string;
    @Input() position: string;
    @Input() e2eAttr: string = 'eui-growl';

    @Output() clicked: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('container') containerViewChild: ElementRef<HTMLDivElement>;

    differ: IterableDiffer<UxMessage>; // TODO: next release make it private
    zIndex: number; // TODO: next release remove it - it's unused
    stopDoCheckPropagation: boolean; // TODO: next release make it private
    timeout: any; // TODO: to be removed on next major release

    constructor(public el: ElementRef, differs: IterableDiffers) {
        this.differ = differs.find([]).create(undefined);
    }

    ngDoCheck() {
        let changes = this.differ.diff(this.value);

        if (changes) {
            // clear timeout in queue to avoid memory leak
            changes.forEachRemovedItem(({ item }) => clearTimeout(item?.timeout));
            // for newly added items create timeout if they are not sticky
            changes.forEachAddedItem(({ item }) => this.createRemovalTimeout(item));
        }
    }

    remove(msg: UxMessage, msgel?: any): void {
        if (msgel) {
            console.warn('This is DEPRECATED please use it like remove(msg: UxMessage);\n' +
                'This will be a breaking change in the eUI release.');
        }
        this.value.splice(this.findMessageIndex(msg), 1);
    }

    /**
     * Removes all growl messages from the stack
     */
    removeAll(): void {
        if (this.value?.length) {
            this.value.splice(0, this.value.length);
        }
    }

    ngOnDestroy() {
        if (!this.sticky) {
            // make sure to clear any leftover async Timeout for messages
            this.value.forEach(v => clearTimeout(v?.timeout));
        }
    }

    onClick() {
        this.clicked.emit();
    }

    /**
     * Removes all growl messages from the stack
     * @param msg UxMessage
     */
    private createRemovalTimeout(value: UxMessage) {
        // if message it's NOT sticky and there's not any async running timeout
        if (!value.sticky && !value.timeout) {
            // set Timeout callback for each message based on the given life value
            value.timeout = setTimeout(() => this.remove(value), value.life || this.life);
        }
    }

    /**
     * Finds UxMessage index of the array otherwise returns -1
     * @param msg UxMessage
     */
    private findMessageIndex(msg: UxMessage): number {
        return (this.value?.length) ? this.value.findIndex((value) => value === msg) : -1;
    }
}
